import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { InterceptorUtil, OCC_USER_ID_ANONYMOUS, OccEndpointsService, USE_CLIENT_TOKEN } from '@spartacus/core';
import { Observable } from 'rxjs';
import { Occ } from '../../occ/occ-models';
import { AnalyticsMetadata } from '../../occ/occ-models/occ-generated.models';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsMetadataConnector {
  constructor(private httpClient: HttpClient, private occEndpointsService: OccEndpointsService) {}

  load(userId: string): Observable<AnalyticsMetadata> {
    let headers = new HttpHeaders();
    if (userId === OCC_USER_ID_ANONYMOUS) {
      headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);
    }
    const url = this.occEndpointsService.buildUrl('analyticsMetadata', { urlParams: { userId } });
    return this.httpClient.get<Occ.AnalyticsMetadata>(url, { headers });
  }
}
